"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgGlobeStand01 = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M19.339 1.661a1 1 0 1 0-1.415 1.414c4.1 4.099 4.101 10.743.006 14.844a.262.262 0 0 1-.006.005c-3.861 3.862-9.984 4.087-14.108.674l1.422-1.422a8.5 8.5 0 1 0-1.414-1.414L2.21 17.375a4.58 4.58 0 0 0-.269.285c-.1.12-.224.293-.296.532a1.52 1.52 0 0 0 .033.965c.086.226.215.388.324.503.088.092.194.185.277.257l.017.015c4.91 4.278 12.361 4.082 17.037-.588l.006-.005c4.881-4.882 4.881-12.796 0-17.678Z", fill: "currentColor" }) }))); };
exports.default = SvgGlobeStand01;
